import { api } from "../../util";

export const getProjectsApiCall = (payload = {}) => {
  let url = "/projects";

  return api.get(url, {
    params: {
      page: payload.page,
      limit: payload.limit,
      filter: payload.filter || {},
      sort: payload.sort,
      //   search: payload.search,
    },
  });
};
